import React from "react";

export type VcScrollCtx = {
  vcScroll: boolean;
  setVcScroll: (v: boolean) => void;
};

export const VehicleCardsScrollContext = React.createContext<VcScrollCtx>({
  vcScroll: false,
  setVcScroll: () => {},
});

export const useVehicleCardsScroll = () =>
  React.useContext(VehicleCardsScrollContext);
